import { jsxs as M, jsx as b } from "react/jsx-runtime";
import { useRef as A, useState as N, useMemo as C, useCallback as _, useEffect as D } from "react";
import { V as v } from "./index-D6IbTb4M.js";
import { c as H } from "./clsx-OuTLNxxd.js";
import { B as V } from "./Button-DIvSLTPg.js";
import './TableScrollContainer.css';const x = 600, I = ({ cellWidth: k, maxRows: p }) => {
  const d = A(null), [a, c] = N(0), [W, T] = N(!1), [l, B] = N({
    pinCount: 0,
    rowCount: 0,
    headings: null
  }), [S, g] = N({
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  }), e = C(
    () => S.left || S.right,
    [S.left, S.right]
  ), i = _(() => {
    if (!d.current) return null;
    const t = d.current.querySelector("table"), o = d.current.getElementsByTagName("thead")[0], n = d.current.getElementsByTagName("tbody")[0], u = d.current.getElementsByTagName("tfoot")[0];
    if (!t || !o) return null;
    const s = o.getElementsByTagName("th");
    return s.length ? { container: d.current, table: t, headings: s, tbody: n, tfoot: u } : null;
  }, []), h = _(() => {
    var m;
    const t = i();
    if (!t) return;
    const { headings: o, tbody: n } = t, u = ((m = n == null ? void 0 : n.getElementsByTagName("tr")) == null ? void 0 : m.length) || 0, s = W ? 0 : [...o].filter((w) => w.dataset.pinned === "true").length;
    B({
      pinCount: s,
      rowCount: u,
      headings: o
    });
  }, [i, W]), y = _(() => {
    const t = i();
    if (!t) return { left: !1, right: !1 };
    const { container: o, table: n } = t, u = o.clientWidth, s = n.clientWidth, m = a >= 0, w = a <= -(s - u);
    return {
      left: !m,
      right: !w && s > u
    };
  }, [a, i]), E = _(() => {
    if (!l.headings)
      return { top: !1, bottom: !1 };
    const t = i();
    if (!t || !t.tbody || !t.tfoot)
      return { top: !1, bottom: !1 };
    const { tbody: o, tfoot: n } = t, u = l.headings[0].getBoundingClientRect().bottom, s = n.getBoundingClientRect().top, m = o.getBoundingClientRect().top, w = o.getBoundingClientRect().bottom;
    return {
      top: m < u,
      bottom: w > s
    };
  }, [i, l.headings]), f = _(
    (t = !1) => {
      const o = y();
      if (t) {
        const n = E();
        g({
          ...o,
          ...n
        });
      } else
        g((n) => ({
          ...n,
          ...o
        }));
    },
    [y, E]
  ), z = _(
    (t) => {
      const o = i();
      if (!o) return;
      const { container: n, table: u } = o, s = n.clientWidth, m = u.clientWidth, w = Math.max(0, m - s), F = t === "left" ? Math.min(0, a + k) : Math.max(-w, a - k);
      c(F), f();
    },
    [k, f, a, i]
  );
  return D(() => {
    T(window.innerWidth <= x), h();
    const t = !!p && !!l.rowCount && p < l.rowCount;
    f(t);
    const o = () => {
      T(window.innerWidth <= x), h(), f(!!p);
    };
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, [p, f, h, l.rowCount]), {
    scrollRef: d,
    currentTransform: a,
    scrollDirection: S,
    shouldShowScrollButtons: e,
    pinCount: l.pinCount,
    onScrollClick: z,
    checkScroll: f,
    rowCount: l.rowCount
  };
}, L = "_wrapper_17kkw_32", j = "_captionWrapper_17kkw_41", O = "_caption_17kkw_41", $ = "_buttonWrapper_17kkw_58", q = "_button_17kkw_58", K = "_innerWrapper_17kkw_72", P = "_hasMaxHeight_17kkw_78", X = "_hasScrollShadowEnd_17kkw_82", G = "_hasScrollShadowStart_17kkw_91", J = "_hasScrollShadowTop_17kkw_100", Q = "_hasScrollShadowBottom_17kkw_109", R = "_hasVerticalScroll_17kkw_126", U = "_hasHorizontalScroll_17kkw_130", Y = "_scrollFullWidth_17kkw_134", r = {
  wrapper: L,
  captionWrapper: j,
  caption: O,
  buttonWrapper: $,
  button: q,
  innerWrapper: K,
  hasMaxHeight: P,
  hasScrollShadowEnd: X,
  hasScrollShadowStart: G,
  hasScrollShadowTop: J,
  hasScrollShadowBottom: Q,
  hasVerticalScroll: R,
  hasHorizontalScroll: U,
  scrollFullWidth: Y
}, rt = ({
  caption: k,
  cellWidth: p = 60,
  children: d,
  className: a,
  maxRows: c,
  ...W
}) => {
  const {
    checkScroll: T,
    currentTransform: l,
    onScrollClick: B,
    pinCount: S,
    rowCount: g,
    scrollDirection: e,
    scrollRef: i,
    shouldShowScrollButtons: h
  } = I({
    maxRows: c,
    cellWidth: p
  }), y = C(
    () => H(
      r.wrapper,
      {
        [r.hasScrollShadowTop]: e.top,
        [r.hasScrollShadowBottom]: e.bottom,
        [r.scrollFullWidth]: !e.left || !h,
        [r.hasVerticalScroll]: e.top || e.bottom,
        [r.hasHorizontalScroll]: e.left || e.right
      },
      a
    ),
    [a, e, h]
  ), E = C(
    () => H(r.innerWrapper, {
      [r.hasMaxHeight]: c,
      [r.hasScrollShadowEnd]: h && e.right,
      [r.hasScrollShadowStart]: h && e.left
    }),
    [c, h, e.right, e.left]
  ), f = C(
    () => ({
      "--maxRows": g && c && g < c ? g : c,
      "--cellWidth": `${p}px`,
      "--pinCount": S
    }),
    [p, c, S, g]
  ), z = C(
    () => ({
      "--table-horizontal-offset": `translateX(${l}px)`
    }),
    [l]
  );
  return /* @__PURE__ */ M("div", { className: y, style: f, ...W, children: [
    /* @__PURE__ */ M("div", { className: r.captionWrapper, children: [
      /* @__PURE__ */ b("h2", { className: r.caption, children: k }),
      h && /* @__PURE__ */ M("div", { className: r.buttonWrapper, "data-testid": "scroll-controls", children: [
        /* @__PURE__ */ b(
          V,
          {
            "aria-label": "scroll table left",
            className: r.button,
            disabled: !e.left,
            onClick: () => B("left"),
            variant: "ghost",
            children: /* @__PURE__ */ b(v, { size: "xsm" })
          }
        ),
        /* @__PURE__ */ b(
          V,
          {
            "aria-label": "scroll table right",
            className: r.button,
            disabled: !e.right,
            onClick: () => B("right"),
            variant: "ghost",
            children: /* @__PURE__ */ b(v, { size: "xsm" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ b(
      "div",
      {
        className: E,
        onScroll: () => T(!!c),
        ref: i,
        style: z,
        children: d
      }
    )
  ] });
};
export {
  rt as T
};
